"use client";

import Link, { type LinkProps } from "next/link";
import type { AnchorHTMLAttributes, ReactNode } from "react";
import { captureProductEvent } from "@/lib/posthog/product-events";

type TrackingProperties = Record<string, string | number | boolean | null | undefined>;

type TrackedLinkProps = LinkProps &
  Omit<AnchorHTMLAttributes<HTMLAnchorElement>, keyof LinkProps> & {
    children: ReactNode;
    tracking: TrackingProperties;
  };

export function TrackedLink({
  children,
  tracking,
  onClick,
  ...props
}: TrackedLinkProps) {
  return (
    <Link
      {...props}
      onClick={(event) => {
        captureProductEvent("cta_clicked", tracking);
        onClick?.(event);
      }}
    >
      {children}
    </Link>
  );
}

type TrackedAnchorProps = AnchorHTMLAttributes<HTMLAnchorElement> & {
  children: ReactNode;
  tracking: TrackingProperties;
};

export function TrackedAnchor({
  children,
  tracking,
  onClick,
  ...props
}: TrackedAnchorProps) {
  return (
    <a
      {...props}
      onClick={(event) => {
        captureProductEvent("cta_clicked", tracking);
        onClick?.(event);
      }}
    >
      {children}
    </a>
  );
}
